import * as React from 'react';
import camelCase from 'lodash/camelCase';

import { Box } from '../../../Layout/Box';
import { ScreenReaderOnly } from '../../../../Accessibility/ScreenReaderOnly';
import { IInputRadioField } from '../common';
import { useFocusControl, useUniqueId } from '../../../Utils';
import { useFieldSetGroupContext } from '../../FieldSet/FieldSetGroup';

import { RadioCardContentContainer, RadioCardInput, RadioCardLabel } from './RadioCardStyles';

export interface IInputRadioCardFieldProps extends IInputRadioField {
  srText: string;
}

// exporting here is a work around for this issue https://github.com/microsoft/tslint-microsoft-contrib/issues/667
export const InputRadioCardField =
  React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement> & IInputRadioCardFieldProps>((
  {
    children,
    groupName: groupNameComponent,
    hasError: hasErrorComponent,
    inputProps,
    srText,
    value,
  },
  ref
) => {
  const { clickFocus, stopClickFocus, resetClickFocus } = useFocusControl();
  const { errorIds, groupName, hasError, helperTextId } = useFieldSetGroupContext();

  const inputId: string = camelCase(`${groupName || groupNameComponent} ${value} id`);
  const contentId = useUniqueId('description');
  const RadioCard = Box;

  return (
    <RadioCard position='relative'>
      <RadioCardInput
        {...inputProps}
        aria-describedby={errorIds ? `${errorIds} ${helperTextId && helperTextId} ${contentId}` : `${helperTextId} ${contentId}`}
        id={inputId}
        name={groupName || groupNameComponent}
        ref={ref}
        type='radio'
        value={value}
        onBlur={resetClickFocus}
        error={hasError || hasErrorComponent}
        clickFocus={clickFocus}
      />
      <RadioCardLabel htmlFor={inputId} onMouseDown={stopClickFocus}>
        <ScreenReaderOnly as='span'>
          {srText}
        </ScreenReaderOnly>
      </RadioCardLabel>
      <RadioCardContentContainer id={contentId}>
        {children}
      </RadioCardContentContainer>
    </RadioCard>
  );
});

export default InputRadioCardField;
